import { useState, useCallback, useEffect } from 'react';
import { useHistory } from 'react-router-dom';

export interface Props {
  availableYears: Array<number>;
  selectedYears: Array<number>;
  setSelectedYears: (selectedYears) => void;
}

export const useContainer = () => {
  const [selectedPage, setSelectedPage] = useState<string>();
  const history = useHistory();

  const changeSelectedPage = useCallback((path) => {
    history.push(path);
  }, []);

  useEffect(() => {
    setSelectedPage(history.location.pathname);
  }, [history.location.pathname]);

  return {
    selectedPage,
    changeSelectedPage,
  };
};
